import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Dialog, Toast, Loading, Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import zhHK from 'vant/es/locale/lang/zh-HK';
import zhTW from 'vant/es/locale/lang/zh-TW'
import 'font-awesome/css/font-awesome.min.css'
// import 'vant/lib/index.css'
import './styles/index.scss'
import browser, { platform, ua } from './utils/browser'
import ErrorCollect from '@/utils/ErrorCollect'
import { H5_VERSION, SDK_VERSION } from '@/utils/properties'
import VConsole from 'vconsole'
import VueClipboard from 'vue-clipboard2'
import { $t, CURRENT_LANG, SIMPLE_LANG, COMPLEX_LANG } from '@/utils/languages'

Vue.prototype.$t = $t // 国际化翻译
// Vant组件国际化
const curLang = CURRENT_LANG
if (SIMPLE_LANG.includes(curLang)) {
    Locale.use('zh-CN', zhCN);
} else if (COMPLEX_LANG.includes(curLang)) {
    if (curLang === 'zh-TW') {
        Locale.use('zh-TW', zhTW);
    } else {
        Locale.use('zh-HK', zhHK);
    }
} else {
    Locale.use('en-US', enUS);
}


window.vConsole = null

if (process.env.NODE_ENV === 'development' ||
    /test|gray/g.test(window.location.host)) {
    if (VConsole) {
        window.vConsole = new VConsole()
    }
}

const ManualOpenVConsoleKey = '::MANUAL_OPEN_V_CONSOLE::'
// const ManualCloseVConsoleKey = '::MANUAL_CLOSE_V_CONSOLE::'

window.addEventListener(ManualOpenVConsoleKey, () => {
    console.log('manual open vConsole')
    if (!window.vConsole) {
        window.vConsole = new VConsole()
    }
})

window.openVConsole = () => {
    const OpenVConsoleEvent = new CustomEvent(ManualOpenVConsoleKey, {
        detail: {},
        bubbles: false,
        cancelable: true,
    })
    if (window.dispatchEvent) {
        window.dispatchEvent(OpenVConsoleEvent)
    } else if (window.fireEvent) {
        window.fireEvent(OpenVConsoleEvent)
    }
}

// 暂时先注释错误日志
// export const errorCollect = new ErrorCollect({
//     hostList: ['//apixk.3698k.com'],
//     baseData: {
//         h5_version: H5_VERSION,
//         sdk_version: SDK_VERSION,
//         platform: platform,
//         ua,
//         app_type: 'h5sdk',
//     },
// })

Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(VueClipboard)
let isiOS = browser.isiOS
let isAndroid = browser.isAndroid
let isReset = true

if (isiOS) {
    document.body.addEventListener('focusin', () => {
        isReset = false
    })
    document.body.addEventListener('focusout', () => {
        isReset = true
        setTimeout(() => {
            // 可能切换输入表单，此时不需要归位
            if (isReset) {
                window.scroll(0, 0) // 失去焦点后强制回到顶点
            }
        }, 300)
    })
} else if (isAndroid) {
    let h = document.body.scrollHeight
    let resizeHeight = document.documentElement.clientHeight ||
        document.body.clientHeight
    if (resizeHeight < h) {
        //当软键盘弹起，在此处操作
        isReset = false
    } else {
        //当软键盘收起，在此处操作
        isReset = true
        setTimeout(() => {
            if (isReset) {
                window.scroll(0, 0)//失焦后强制让页面归位
            }
        }, 300)
    }
}
Vue.config.productionTip = false
export default new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
